// Bỏ dấu + chữ thường để tìm "long ho" ra "Long Tranh Hổ Đấu"
function normalize(text) {
  return (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[đĐ]/g, 'd')
    .toLowerCase();
}

// Mỗi từ gõ vào phải có trong một trong các trường, không cần liền nhau
export function matchesFields(fields, query) {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  const text = normalize(fields.join(' '));
  return words.every((word) => text.includes(word));
}

// Trang chủ: tìm danh mục theo tên
export const matchesCategory = (category, query) => matchesFields([category.name], query);

// Trong danh mục: tìm tranh theo mã chứng nhận / chủ sở hữu / kích thước
export const matchesArtwork = (artwork, query) => matchesFields([artwork.code, artwork.ownerName, artwork.size], query);

